import { render, staticRenderFns } from "./order_review_modal.vue?vue&type=template&id=38e7799d&"
import script from "./order_review_modal.vue?vue&type=script&lang=coffee&"
export * from "./order_review_modal.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports